export default __webpack_public_path__ + "static/media/b6.76365e03.jpeg";